import { combineReducers } from "redux";
import listDevicesByAdmin from './listDevicesByAdmin/listDevicesByAdmin'

const deviceReducer = combineReducers({
    listDevicesByAdmin
})

export default deviceReducer;